<template>
  <div>
    <h1>OAuth 2.0 Authorize Example</h1>
    <div v-if="code">
      <h3>
        <i class="fa fa-check"></i>
        Success
      </h3>
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="app-parameter-name">code</td>
              <td class="app-code-value">{{ code }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">state</td>
              <td class="app-state-value">{{ state }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="error">
      <h3>
        <i class="fa fa-times"></i>
        Error
      </h3>
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="app-parameter-name">error</td>
              <td class="app-error-type-value">{{ error }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">error_status</td>
              <td>{{ error_status }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">error_description</td>
              <td>{{ error_description }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">error_at</td>
              <td>{{ error_at }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">error_trace_id</td>
              <td>{{ error_trace_id }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">error_uri</td>
              <td>
                <a :href="error_uri">{{ error_uri }}</a>
              </td>
            </tr>
            <tr>
              <td class="app-parameter-name">error_on</td>
              <td>{{ error_on }}</td>
            </tr>
            <tr>
              <td class="app-parameter-name">state</td>
              <td class="app-state-value">{{ state }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <a href="/th/docs/overview/v1/oauth2-authorization-code-default"
      >Back to OAuth 2.0 Authorization Code - Default</a
    >
    <br />
    <a href="/th/docs/overview/v1/oauth2-authorization-code-pkce"
      >Back to OAuth 2.0 Authorization Code - PKCE</a
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: null,
      state: null,
      error: null,
      error_status: null,
      error_description: null,
      error_at: null,
      error_trace_id: null,
      error_uri: null,
      error_on: null,
    };
  },
  mounted() {
    const query = new Object(this.$route.query);
    console.log(this.$route.query);
    for (let prop in query) {
      if (Object.prototype.hasOwnProperty.call(query, prop)) {
        this[prop] = query[prop];
      }
    }
  },
};
</script>

<style scoped>
table {
  width: 100%;
}
thead {
  background-color: #f3f4f5;
}
thead tr {
  border-bottom: solid 2px #c7c7c7;
}
thead th {
  padding-left: 5px;
  padding-right: 5px;
}
tbody tr {
  border-bottom: solid 1px #e4e4e4;
}
tbody td {
  padding: 0.2rem 0.3rem;
}
.app-parameter-name {
  width: 120px;
  font-weight: bold;
}
.app-code-value {
  color: #63b363;
  font-weight: bold;
}
.app-error-type-value {
  color: #e65656;
  font-weight: bold;
}

.app-state-value {
  color: #777;
}

.fa {
  background-color: #e6e6e6;
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.fa-check {
  color: #4ccc4c;
  font-size: 80%;
}

.fa-times {
  color: #f17979;
  font-size: 90%;
}
</style>